import { connect } from 'react-redux';
import ArcadeCabinetForm from './Form';
import {
    setArcadeCabinetValue,
    loadArcadeCabinetForEditing,
    createArcadeCabinet,
    updateArcadeCabinet
} from '../../actions';import { getArcadeCabinetsCabinet } from '../../selectors';
import { isBundleUpdating } from 'app/dux/cmx/selectors';

const mapStateToProps = state => ({
    cabinet: getArcadeCabinetsCabinet(state),
    isBundleUpdating: isBundleUpdating(state)
});
const mapDispatchToProps = {
    setArcadeCabinetValue,
    loadArcadeCabinetForEditing,
    createArcadeCabinet,
    updateArcadeCabinet
};

export default connect(mapStateToProps, mapDispatchToProps)(ArcadeCabinetForm);
